/* import __COLOCATED_TEMPLATE__ from './use-in-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();